module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-petit-gift-b5bb23d35c017f0671da32ddae0455ab.jpg";